module.exports = __webpack_public_path__ + "static/media/04-thoughts-on-the-bbc.9e51d3bd.mp3";